import { memoize } from 'lodash';
import { createSelector } from 'reselect';
import { State } from '.';
import { NLMPatientEducationDefinition } from '../../models/nlm-patient-education-definition';

const getOtherNLMPatientEducationDefinitionIdsSelector = createSelector(
    (state: State) => state.byId,
    (byId: Dictionary<NLMPatientEducationDefinition>) => memoize((
        ids: Undefinable<number>[]
    ) => ids.filter(x => x && !byId[x]) as number[])
);

export const selectors = {
    getLoading: (
        state: State,
        loadingKey: string
    ): boolean => state.loading[loadingKey] || false,
    getOtherNLMPatientEducationDefinitionIds: (
        state: State,
        ids: Undefinable<number>[]
    ): number[] => getOtherNLMPatientEducationDefinitionIdsSelector(state)(ids),
    getNLMPatientEducationDefinition: (
        state: State,
        id: Undefinable<number>
    ): Undefinable<NLMPatientEducationDefinition> => state.byId[id || '']
};
